import React from "react";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import "./AdnSection.css";

/**
 * AdnSection – Vista pública de la sección "ADN Teansari".
 * Carga el contenido HTML desde el endpoint genérico site_content
 * y lo renderiza dentro de la tarjeta temática.
 */
class AdnSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contentHtml: "",
      loaded: false,
    };
  }

  componentDidMount() {
    this.loadContent();
  }

  loadContent() {
    if (this.props.onLoading) this.props.onLoading(true);

    doFetch("TEAN", "getSiteContent?key=ADN_TEANSARI")
      .then((res) => res.json())
      .then((json) => {
        if (json.STATE === "SUCCESS" && json.DATA) {
          this.setState({ contentHtml: json.DATA.contentValue || "", loaded: true });
        } else {
          this.setState({ loaded: true });
        }
      })
      .catch((err) => {
        console.error("Error loading ADN content:", err);
        this.setState({ loaded: true });
      })
      .finally(() => {
        if (this.props.onLoading) this.props.onLoading(false);
      });
  }

  render() {
    const { contentHtml, loaded } = this.state;

    return (
      <div className="adn-section-container">
        <h1 className="adn-main-title">
          <span className="adn-main-title-primary">ADN </span>
          <span className="adn-main-title-secondary">TEANSARI</span>
        </h1>
        <div className="adn-card">
          {loaded && contentHtml ? (
            <div
              className="adn-content"
              dangerouslySetInnerHTML={{ __html: contentHtml }}
            />
          ) : loaded ? (
            <p className="adn-paragraph text-muted">
              No hay contenido disponible todavía.
            </p>
          ) : null}
        </div>
      </div>
    );
  }
}

export default AdnSection;